module.exports = __webpack_public_path__ + "img/404.fd02ba55.png";